export default __webpack_public_path__ + "static/media/word.25cbcd06.svg";